import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import LiveTalkDrawer from './LiveTalkDrawer';
import './LiveTalk.css';

/**
 * Floating "Live Talk" button + drawer wrapper. Drop this anywhere in an
 * agent dashboard and it'll bind a talk surface to that agent.
 */
const ACCENT_DEFAULTS = {
  nova:     ['#7dd3fc', '#a78bfa'],   // starlight cyan → violet
  orion:    ['#a78bfa', '#d946ef'],   // violet → magenta
  vega:     ['#6ee7b7', '#7dd3fc'],   // mint → cyan
  atlas:    ['#fcd34d', '#fb923c'],   // gold → amber
  karbon:   ['#00e5b0', '#7dd3fc'],   // mangrove → cyan
  scribe:   ['#94a3b8', '#a78bfa'],
  quill:    ['#f472b6', '#a78bfa'],
  producer: ['#fb7185', '#fcd34d'],
  delta:    ['#94a3b8', '#7dd3fc'],
};

export default function LiveTalkButton({ agent, label, accent, accent2 }) {
  const [open, setOpen] = useState(false);
  const [a, a2] = ACCENT_DEFAULTS[agent] || ['#a78bfa', '#7dd3fc'];
  const finalAccent = accent || a;
  const finalAccent2 = accent2 || a2;

  // Portal both the launcher pill and the drawer to document.body so the
  // surrounding agent-shell CSS (e.g. `.orion-app > * { position: relative }`)
  // can't override `position: fixed` and stretch the launcher to full width.
  const node = (
    <>
      <button
        className="live-talk-launcher"
        onClick={() => setOpen(true)}
        data-testid={`live-talk-launcher-${agent}`}
        style={{ '--talk-accent': finalAccent, '--talk-accent-2': finalAccent2 }}
        title={`Live talk with ${agent}`}
      >
        <span className="lt-pulse" />
        {label || `Talk to ${agent}`}
      </button>
      <LiveTalkDrawer
        open={open}
        onClose={() => setOpen(false)}
        agent={agent}
        accent={finalAccent}
        accent2={finalAccent2}
      />
    </>
  );

  if (typeof document === 'undefined' || !document.body) {
    return node;
  }
  return createPortal(node, document.body);
}
